import { SupportChatOrigins } from '@wix/wix-help-widget-common/types';

import { isString } from '../../util/guards';

export function isSupportChatOrigins(origin: unknown): origin is SupportChatOrigins {
  if (!isString(origin)) {
    return false;
  }

  const origins = [
    'ADI',
    'Editor',
    'StudioEditor',
    'Editor3',
    'Blocks',
    'BusinessManager',
    'IntroFunnel',
    'TemplatesGallery',
    'TemplatesViewer',
    'PackagePicker',
    'AcceptPayments',
    'WixPayments',
    'Hopp',
    'AccountManager',
    'SitesList',
    'Landing',
    'Contact',
    'test',
    'USP',
  ] as const;

  return origins.includes(origin as SupportChatOrigins);
}
